var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 5.33333C28 4.59695 27.403 4 26.6667 4C25.9303 4 25.3333 4.59695 25.3333 5.33333L25.3333 26.6667C25.3333 27.403 25.9303 28 26.6667 28C27.403 28 28 27.403 28 26.6667L28 5.33333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2761 15.0569L17.219 9.9999C16.6983 9.4792 15.854 9.4792 15.3333 9.9999C14.8126 10.5206 14.8126 11.3648 15.3333 11.8855L18.1144 14.6664L5.33333 14.6664C4.59695 14.6664 4 15.2633 4 15.9997C4 16.7361 4.59695 17.333 5.33333 17.333L18.1144 17.333L15.3333 20.1141C14.8126 20.6348 14.8126 21.479 15.3333 21.9997C15.854 22.5204 16.6983 22.5204 17.219 21.9997L22.2761 16.9425C22.7968 16.4218 22.7968 15.5776 22.2761 15.0569Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.df1f2b691c0bdae3bc6eb39cc07f1859.svg";
export { ForwardRef as ReactComponent };